import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {Alert} from "antd";
import classes from "./Alert.module.scss";
import {selectSiloGroupsState} from "../../store/selectors";
import {WinStorage} from "../../services/AuthSrorage";
import {silogroupAC} from "../../store/branches/silo-group/actionCreators";
import {LoadingStatus} from "../../store/status";


type AlertNotification = "success" | "info" | "warning" | "error"

const SiloGroupAlert = () => {
    const {status} = useSelector(selectSiloGroupsState);
    const errorMessage = WinStorage.getErrorMessage();
    const dispatch = useDispatch();

    const setTimer = () => {
        setTimeout(() => {
            dispatch(silogroupAC.setSiloGroupLoadingStatus(LoadingStatus.NEVER));
            WinStorage.removeErrorMessage();
        }, 5000);
    };

    const alertNotification = (message: typeof errorMessage | string, type: AlertNotification) => {
        return <Alert
            message={message}
            type={type}
            showIcon
            closable
            className={classes.alert}
        />;
    };

  if (status === LoadingStatus.ERROR) {
        setTimer();
        // Use the error message from storage or a generic failure notice
        const message = errorMessage || "Configuration save failed due to an unknown error.";
        return alertNotification(message, "error");
    }

    if (status === LoadingStatus.SUCCESS) {
        setTimer();
       return alertNotification("Your feedback has been saved successfully.", "success");
    }
    return null;
};
export default SiloGroupAlert;
